//Make sure controller & component names are different from portal's!
(function (ng, app) {
    app.config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('Portal.CarriersTraining',
                {
                    url: '/CarriersAndTraining',
                    component: 'carriersTrainingComponent',
                    requiredPermissions: "SureLc:Access"
                });
        }
    ]);

    app.component('carriersTrainingComponent', {
        templateUrl: 'App.Portal/States/CarriersTraining/CarriersTraining.template.html',
        controller: 'CarriersTrainingController',
        bindings: {
            user: '<',
            userGroup: '<',
            onBehalfOfUserGroup: '<',
            trainings: '<',
        }
    });

    app.controller('CarriersTrainingController', CarriersTrainingController);

    CarriersTrainingController.$inject = ['trainingConstant', 'permissionService'];

    function CarriersTrainingController(trainingConstant, permissionService) {
        var $ctrl = this;

        ng.extend($ctrl, {
            showAppointments: true,
            trainings: {
                GeneralTraining: [
                    {
                        Title: "Long Term Care Training",
                        Description: "Carrier Specific Training and State Annuity Training must be completed prior to soliciting business. ", //Failure to complete the required training will result in significant delays which often includes newly signed paperwork.
                        Link: "https://www.training.figmarketing.com/post/long-term-care-training",
                        ImageUrl: null
                    },
                    {
                        Title: "Anti-Money Laundering",
                        Description: "All licensed insurance agents are required to complete Anti-Money Laundering training. ", //Each carrier requires all advisors to complete an Anti- Money Laundering training course every two years.
                        Link: "https://www.training.figmarketing.com/post/anti-money-laundering",
                        ImageUrl: null
                    },
                    {
                        Title: "NAIC 4-Hour Annuity Training",
                        Description: "Carrier Specific Training and State Annuity Training must be completed prior to soliciting business. ", //Failure to complete the required training will result in significant delays which often includes newly signed paperwork.
                        Link: "https://www.training.figmarketing.com/post/naic-annuity-suitability",
                        ImageUrl: null
                    },
                    {
                        Title: "New York - Reg 187 Training",
                        Description: "Carrier Specific Training and State Annuity Training must be completed prior to soliciting business.", // Failure to complete the required training will result in significant delays which often includes newly signed paperwork.
                        Link: "https://www.training.figmarketing.com/post/new-york-reg-187-training",
                        ImageUrl: null
                    },
                ],}
        });

        $ctrl.$onInit = function () {
            $ctrl.trainings = trainingConstant;
            $ctrl.showAppointments = permissionService.hasAllPermissions('Reports:Contracting'); //expand Get Contracted and General Training if no Appointments reporting permision
        }
    }
})(window.angular, window.app);